import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal, closeModal } from "../../store/slices/addModalSlice";
import { FaCirclePlus } from "react-icons/fa6";
import { FaRegCircleXmark } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { fetchDataCategories } from "../../store/slices/apiCategorySlice";
import {
  createDataExams,
  fetchDataExams,
} from "../../store/slices/apiExamsSlice";
import Select from "react-select";

const AddModalExams = ({
  title,
  submitButtonText,
  onClose,
  onSuccess,
  inputLabel1,
  inputLabel2,
  premiumStatus,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isOpen = useSelector((state) => state.addModal.isOpen);

  const [examName, setExamName] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const categoryOptions = useSelector((state) => state.apiCategory.data);
  const [premiumExams, setPremiumExams] = useState(false);

  useEffect(() => {
    dispatch(fetchDataCategories());
  }, [dispatch]);

  const handlePremiumExams = (isChecked) => {
    setPremiumExams(isChecked);
  };

  const handleCloseModal = () => {
    if (onClose) onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const selectedCategoryId = selectedOption ? selectedOption.value : null;

    const data = {
      name: examName,
      categoryId: selectedCategoryId,
      isPremium: premiumExams ? 1 : 0,
    };

    try {
      await dispatch(createDataExams(data));

      if (onSuccess) {
        onSuccess();
      }
      setExamName("");
      setSelectedOption(null);
      setPremiumExams(false);
      handleCloseModal();
      if (onClose) onClose();

      toast.success("Testi u shtua me sukses !");
      dispatch(fetchDataExams());
    } catch (error) {
      console.log("Error submitting data:", error);
    }
  };

  const handleOpenModal = () => {
    dispatch(openModal());
  };

  const handleOptionChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  return (
    <div>
      <button
        data-modal-target="popup-modal"
        data-modal-toggle="popup-modal"
        onClick={handleOpenModal}
        className="text-white bg-blue-500 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-3 py-2 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
      >
        Shto Test
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4 py-6 overflow-auto">
          <div className="bg-gray-900 bg-opacity-40 absolute inset-0"></div>

          <div
            className="relative bg-white rounded-lg shadow-lg w-full max-w-md mx-auto"
            style={{ minWidth: "280px" }}
          >
            <button
              type="button"
              onClick={handleCloseModal}
              className="absolute top-3 right-3 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-full w-8 h-8 flex justify-center items-center z-10"
              aria-label="Close modal"
            >
              <FaRegCircleXmark style={{ width: 20, height: 20 }} />
            </button>

            <div className="p-6 text-center">
              <h3 className="mb-5 text-xl font-normal text-gray-500 dark:text-gray-400">
                {title}
              </h3>

              <form className="space-y-6 text-start" onSubmit={handleSubmit}>
                <div>
                  <label
                    htmlFor="input1"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    {inputLabel1}:
                  </label>
                  <input
                    type="text"
                    name="input1"
                    id="input1"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    placeholder=""
                    value={examName}
                    onChange={(e) => setExamName(e.target.value)}
                    required
                  />
                </div>

                {inputLabel2 && (
                  <div>
                    <label
                      htmlFor="input2"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      {inputLabel2}:
                    </label>
                    <Select
                      isClearable
                      name="input2"
                      id="input2"
                      value={selectedOption}
                      onChange={handleOptionChange}
                      options={categoryOptions.map((option) => ({
                        value: option.id,
                        label: option.name,
                      }))}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    />
                  </div>
                )}

                {premiumStatus && (
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      Premium:
                    </label>
                    <div className="flex flex-wrap gap-2">
                      <button
                        type="button"
                        className={`text-sm rounded-lg px-3 py-1 ${
                          premiumExams
                            ? "bg-green-500 text-white"
                            : "bg-gray-200 text-gray-700"
                        }`}
                        onClick={() => handlePremiumExams(true)}
                      >
                        Po
                      </button>
                      <button
                        type="button"
                        className={`text-sm rounded-lg px-3 py-1 ${
                          !premiumExams
                            ? "bg-red-500 text-white"
                            : "bg-gray-200 text-gray-700"
                        }`}
                        onClick={() => handlePremiumExams(false)}
                      >
                        Jo
                      </button>
                    </div>
                  </div>
                )}

                <div className="flex justify-center flex-wrap gap-3 mt-4">
                  <button
                    data-modal-hide="popup-modal"
                    type="submit"
                    className="text-white bg-blue-500 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                  >
                    {submitButtonText}
                  </button>

                  <button
                    data-modal-hide="popup-modal"
                    type="button"
                    onClick={handleCloseModal}
                    className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                  >
                    Anulo
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </div>
  );
};

export default AddModalExams;
